import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoVazamento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'vazamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoVazamento({ payload }) {
  try {
    const { movi_codigo, params } = payload;

    yield call(api.delete, `vazamento/${movi_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaovazamento, params } = payload;

    yield call(api.post, 'vazamento', operacaovazamento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/vazamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { movi_codigo } = payload;

    const { data } = yield call(api.get, `vazamento/${movi_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaovazamento, params } = payload;

    yield call(api.put, 'vazamento', operacaovazamento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/vazamento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'vazamento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaovazamento/VAZAMENTO_IN_REQUEST',
    requestOperacaoVazamento
  ),
  takeLatest('@operacaovazamento/DELETE_VAZAMENTO', deleteOperacaoVazamento),
  takeLatest('@operacaovazamento/SUCCESS_REMOVE', requestOperacaoVazamento),
  takeLatest('@operacaovazamento/STORE_VAZAMENTO', store),
  takeLatest('@operacaovazamento/FIND_VAZAMENTO', find),
  takeLatest('@operacaovazamento/UPDATE_VAZAMENTO', update),
  takeLatest('@operacaovazamento/RECORD_FILTERING', applyedFilters),
]);
